"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _index = require("./index.styles"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var Input = function Input(props) {
  return /*#__PURE__*/_react["default"].createElement(_index.StyledInput, props);
};

Input.propTypes = {
  disabled: _propTypes.bool
};
Input.defaultProps = {
  disabled: false
};
var _default = Input;
exports["default"] = _default;